<template>
    <div>
        <b-form-group :label="label">
            <b-form-file v-model="file" accept="image/*" placeholder="Vælg fil..." @change="uploadFile" />
        </b-form-group>

        <b-row>
            <b-col>
                <div v-if="image" class="position-relative d-inline-block ma-5" style="width: 150px;">
                    <b-img class="" thumbnail fluid :src="image" />

                    <b-button variant="gradient-danger" class="btn-icon rounded-circle position-absolute" 
                        style="bottom: 0; right: 0;" @click="deleteFile(image)">
                        <feather-icon icon="Trash2Icon" />
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            value: null,
            url: String,
            deleteUrl: String,
            label: {
                type: String,
                default: "Billede"
            }
        },
        data: () => ({
            file: null
        }),
        computed: {
            image: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() { },
        mounted() { },
        methods: {
            uploadFile(e) {
                var formData = new FormData()
                var imagefiles = e.target.files
                if (imagefiles && imagefiles.length > 0) {
                    imagefiles.forEach(x => {
                        formData.append("file", x)
                    })
                    
                    this.$http.post(this.url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(x => {
                        this.file = null
                        e.target.value = ""

                        this.$emit("uploaded", x.data)
                    })
                }
            },
            deleteFile(item) {
                this.$http.post(this.deleteUrl, { path: item }).then(x => {
                    this.$emit("deleted")
                })
            }
        },
    }
</script>